import request from "../utils/axios";

export const getRegions = (params) => {
  return request({ method: "GET", url: "/regions", params });
};

export const createRegion = (data) => {
  return request({ method: "POST", url: "/regions", data });
};

export const editRegion = (id, data) => {
  return request({ method: "PUT", url: `/regions/${id}`, data });
};

export const deleteRegion = (id) => {
  return request({ method: "DELETE", url: `/regions/${id}` });
};
